var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67831 3.98378C9.51662 3.82533 9.25784 3.82533 9.09615 3.98378L2.36805 10.6851C2.20579 10.8458 2.0784 11.0383 1.99381 11.2505L0.530096 14.8589C0.467896 15.0133 0.503893 15.19 0.621577 15.3078C0.731368 15.4799 0.949842 15.5468 1.13721 15.4658L4.74659 14.0357C4.9588 13.9512 5.15131 13.8238 5.31212 13.6616L12.0236 6.95198C12.1023 6.87392 12.1466 6.76766 12.1466 6.65682C12.1466 6.54597 12.1023 6.43972 12.0236 6.36166L9.67831 3.98378ZM14.5851 0.865924L15.134 1.41467C15.368 1.64833 15.4996 1.96533 15.4999 2.29598L15.4999 2.92786C15.5041 3.26427 15.3721 3.58809 15.134 3.82581L13.612 5.33069C13.4504 5.48914 13.1916 5.48914 13.0299 5.33069L10.6597 2.99438C10.5809 2.91632 10.5367 2.81007 10.5367 2.69922C10.5367 2.58838 10.5809 2.48212 10.6597 2.40406L12.1733 0.865924C12.4111 0.627857 12.735 0.495932 13.0715 0.500095L13.7035 0.500095C14.0343 0.500387 14.3514 0.631972 14.5851 0.865924Z",
    fill: "#4494FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.390ed25c.svg";
export { ForwardRef as ReactComponent };